"use client";

import Link from "next/link";
import { Kicker } from "@/components/ui/editorial";

const PersonalBanner = () => {
	return (
		<section className="pt-16 pb-12">
			{/*
			 * El contenedor del H1 es el elemento LCP. Se renderiza estático (sin
			 * animación de entrada): framer-motion serializa `initial` como estilo
			 * inline en el SSR y resuelve la animación solo al hidratar el bundle JS,
			 * de modo que cualquier opacidad o transform animado dispara el LCP a
			 * varios segundos en móvil. Las animaciones de entrada se reservan para
			 * las secciones below-the-fold, que no afectan al LCP.
			 */}
			<div className="space-y-6">
				{/* Kicker */}
				<Kicker>— Trabajadora social · Escritora · Activista</Kicker>

				{/* Headline */}
				<h1 className="font-display text-[clamp(2.75rem,7vw,5rem)] leading-[1.05] tracking-tight text-ink">
					Aranzazu Gutiérrez Butler
					<br />
					escribe lo que{" "}
					<em className="italic text-terracotta not-italic">no se ve</em>
				</h1>

				{/* Subtitle */}
				<p className="font-body text-lg md:text-xl text-ink/70 max-w-2xl leading-relaxed">
					Autora de <strong>&quot;Todo lo que no ves&quot;</strong>,
					conferenciante y fundadora de la{" "}
					<strong>Asociación Equilibrio</strong>. Transformando realidades a
					través del trabajo social, la literatura y el activismo.
				</p>

				{/* Actions */}
				<div className="flex flex-wrap gap-4 pt-2">
					<Link
						href="/#proyectos"
						className="bg-ink text-cream rounded-full px-6 py-3 font-body font-semibold text-sm tracking-wide transition-opacity hover:opacity-80"
					>
						Conoce mi obra
					</Link>
					<Link
						href="/#conferencias"
						className="font-body text-sm font-semibold text-ink underline decoration-terracotta underline-offset-4 py-3 transition-opacity hover:opacity-70"
					>
						Conferencias →
					</Link>
				</div>
			</div>
		</section>
	);
};

export default PersonalBanner;
